import React from "react";
import { SearchKeywordType } from "../../pages/VirtualFolderPage/model/DocumentItemModel";
import {
  SearchConditionData,
  SortTypeData,
  DocumentItemType,
  PaginationData,
  EditableSynonymGroup,
  SynonymUpdateInfo,
} from "../../types/documents";
import {
  paginationInitData,
  sortTypeInitData,
  searchConditionInitData,
} from "./init-data";

/** 全文検索データ */
export interface FTSearchData {
  // 検索テキスト
  text?: string;
  keywords?: string[];
  // 検索条件データ
  condition: SearchConditionData;
  // 並び順データ
  sort: SortTypeData;
  // ページネーション
  pagination: PaginationData;
}

/** 全文検索コンテキスト */
export interface FTSearchContextData {
  // 検索前データ（画面と一致する検索データ）
  pending: FTSearchData;
  // 検索済データ (検索結果と一致する検索データ)
  searched: FTSearchData;

  // 検索状態
  //  - ready: 未検索
  //  - pending: 検索保留中
  //  - done: 検索完了
  searchStatus: "ready" | "pending" | "done";

  // 検索結果
  searchResult: DocumentItemType[]; // 検索結果

  // 検索キーワード（解析後 同義語含む）
  searchKeywords: SearchKeywordType[];

  // 検索キーワード（参照・編集用データ）
  editableSearchKeywords: EditableSynonymGroup[];

  // 同義語
  synonym: {
    // 更新状態
    //  - ready: 未更新
    //  - waiting: 更新待ち
    //  - doing: 実行中(API応答待ち)
    //  - done: 完了
    updateStatus: "ready" | "waiting" | "doing" | "done";
    lastUpdateInfo?: SynonymUpdateInfo;
  };

  // 検索条件ドロワー開閉状態
  openSearchConditionDrawer: boolean;

  // 備考(デバッグ用)
  description: string;
}

/** 全文検索コンテキスト初期値 */
export const ftsearchContextInitData: FTSearchContextData = {
  pending: {
    condition: searchConditionInitData,
    sort: sortTypeInitData,
    pagination: paginationInitData,
  },
  searched: {
    condition: searchConditionInitData,
    sort: sortTypeInitData,
    pagination: paginationInitData,
  },
  searchStatus: "ready",
  searchResult: [],
  searchKeywords: [],
  editableSearchKeywords: [],
  synonym: {
    updateStatus: "ready",
  },
  openSearchConditionDrawer: true,
  description: "",
};

/** 全文検索アクションタイプ列挙型 */
export enum FTSearchActionType {
  CLEAR = "CLEAR",
  UPDATE = "UPDATE",
}

/** 全文検索アクション型 */
export interface FTSearchAction {
  type: FTSearchActionType;
  payload?: FTSearchContextData;
}

/** 全文検索リデューサー */
export const FTSearchReducer: React.Reducer<
  FTSearchContextData,
  FTSearchAction
> = (state: FTSearchContextData, action: FTSearchAction) => {
  switch (action.type) {
    case FTSearchActionType.CLEAR:
      // 初期値で更新する
      return ftsearchContextInitData;
    case FTSearchActionType.UPDATE:
      // ディスパッチされた値で更新する
      return {
        ...state,
        ...action.payload,
      };
    default:
      throw Error();
  }
};

/** 全文検索コンテキスト */
export const FTSearchContext = React.createContext<FTSearchContextData>(
  ftsearchContextInitData
);

/** 全文検索ディスパッチャ */
export const FTSearchDispatchContext = React.createContext<
  React.Dispatch<FTSearchAction> | undefined
>(undefined);
